(function () {
    'use strict';
    angular.module('app').controller('ReasonOfCancellationModalController', ReasonOfCancellationModalController);
    ReasonOfCancellationModalController.$inject = [
        '$uibModalInstance',
        '$rootScope',
        'shipmentIds',
        'toastr',
        'Shipments'
    ];

    function ReasonOfCancellationModalController(
        $uibModalInstance,
        $rootScope,
        shipmentIds,
        toastr,
        Shipments
    ){
        const vm =this;
        vm.userDetails = angular.copy($rootScope.GlobalProfile);
        vm.shipmentIds = angular.copy(shipmentIds);

        vm.categoryTypeList = [
            {label: 'ARCHIVE ONLY',value:'CANCELLED'},
            {label: 'MISSING',value:'MISSING'},
            {label: 'DAMAGED',value:'DAMAGED'}
        ]

        vm.closeModal = function(){
            $uibModalInstance.close()
        }

        vm.onSelectType = function(selected){
            // console.log(selected)
        }

        vm.submit = function(form){
            
            if(form.$invalid){
                angular.forEach(form.$error, function(fields){
                    angular.forEach(fields, function(field){
                        field.$setTouched();
                    });
                });
                return;
            }

            const payload =[]
            vm.shipmentIds.forEach(shipmentId => {
                payload.push({
                    shipmentId: shipmentId,
                    trackingStatus: vm.category.value,
                    note: vm.notes
                });
            });

           moveToArchiveShipments(payload)
        }


        init()
        function init(){
            vm.userDetails.name = `${vm.userDetails.firstName} ${vm.userDetails.lastName}`;
            vm.category = vm.categoryTypeList[0];
        }

        function moveToArchiveShipments(payload){
            Shipments.changeStatusShipments(payload, () => {
                toastr.success('Shipment successfully archived');
                $uibModalInstance.close(true)
            }, () => {
                toastr.error('Unable to archive shipment.', 'Please try again later');
                $uibModalInstance.dismiss()
            });
        }
    }
})()


// WEBPACK FOOTER //
// ./js/controllers/shipment/modal/ReasonOfCancellationModalController.js